var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocalesHover68X56(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 58,
    viewBox: "0 0 68 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_4100_19086)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.0089 30.8373C32.7219 30.8373 31.6739 31.8946 31.6739 33.2083V36.5119H36.3535V33.2083C36.3535 31.9014 35.3123 30.8373 34.0186 30.8373H34.0089ZM30.2085 33.2083C30.2085 31.0697 31.9156 29.3492 34.0089 29.3492H34.0186C36.1247 29.3492 37.819 31.0827 37.819 33.2083V38H30.2085V33.2083Z",
    fill: "#61B09D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.4375 26.1746V34.3591C26.4375 35.5454 27.3892 36.5119 28.5575 36.5119H39.47C40.6383 36.5119 41.59 35.5454 41.59 34.3591V26.1746H43.0554V34.3591C43.0554 36.3673 41.4476 38 39.47 38H28.5575C26.5799 38 24.972 36.3673 24.972 34.3591V26.1746H26.4375Z",
    fill: "#61B09D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.0186 27.752C31.7857 27.752 29.9838 25.9095 29.9838 23.6548H31.4492C31.4492 25.0905 32.5978 26.2639 34.0186 26.2639C35.4409 26.2639 36.588 25.099 36.588 23.6548H38.0534C38.0534 25.9208 36.2502 27.752 34.0186 27.752Z",
    fill: "#61B09D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.4436 21.1838C24.6677 19.3658 26.1953 18 28.0006 18H40.0171C41.8233 18 43.3515 19.3671 43.5744 21.1864L43.9013 22.8562C44.0457 23.6003 44.0576 24.4351 43.7597 25.2292C43.2166 26.6793 41.8939 27.752 40.3102 27.752C38.1897 27.752 36.5782 25.8419 36.5782 23.6548V19.4881H31.4395V23.6548C31.4395 25.8549 29.8252 27.752 27.6977 27.752C26.1021 27.752 24.7924 26.6774 24.2402 25.2337L24.2385 25.2292C23.9405 24.435 23.9518 23.5885 24.1083 22.8379L24.4436 21.1838ZM29.974 19.4881H28.0006C26.9255 19.4881 26.0185 20.3074 25.8953 21.389L25.8916 21.4216L25.5432 23.1401L25.5423 23.1445C25.4258 23.7019 25.4372 24.2427 25.6071 24.6972C25.9736 25.653 26.7931 26.2639 27.6977 26.2639C28.8919 26.2639 29.974 25.1649 29.974 23.6548V19.4881ZM38.0437 19.4881V23.6548C38.0437 25.1581 39.1286 26.2639 40.3102 26.2639C41.2078 26.2639 42.0343 25.6503 42.3901 24.6999C42.561 24.2443 42.5732 23.7101 42.4638 23.1451V23.1451L42.4635 23.1438L42.1258 21.419L42.1224 21.389C41.9992 20.3074 41.0923 19.4881 40.0171 19.4881H38.0437Z",
    fill: "#61B09D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_4100_19086",
    x: -14,
    y: -10,
    width: 96,
    height: 84,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0980392 0 0 0 0 0.262745 0 0 0 0 0.498039 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4100_19086"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4100_19086",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocalesHover68X56);
export default __webpack_public_path__ + "static/media/LOCALES-HOVER_68X56.ec885edb6be16ea0a0b496aba20a28f8.svg";
export { ForwardRef as ReactComponent };